const GLOBAL_CONFIG_KEY = "__MATTERLINE_PUBLIC_CONFIG__";

export type PublicRuntimeEnvironment = Record<string, string | boolean | undefined>;

export function publicRuntimeValue(
  name: string,
  buildEnvironment: PublicRuntimeEnvironment
): string | undefined {
  const runtime = (globalThis as Record<string, unknown>)[GLOBAL_CONFIG_KEY];
  if (isPublicRuntimeEnvironment(runtime)) {
    const value = runtime[name];
    if (typeof value === "string") return value.trim() || undefined;
  }
  const value = buildEnvironment[name];
  return typeof value === "string" ? value.trim() || undefined : undefined;
}

function isPublicRuntimeEnvironment(value: unknown): value is PublicRuntimeEnvironment {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
